import { isFarmBasedPolicyType } from '@ourbranch/policy-types';

/**
 * Fee Selector eligibility helpers (issue #34828).
 *
 * `brandConfig` here is the staff-fe brand config object (the default export of
 * @ourbranch/brand-config / brand-config-fe), so the per-LOB fee amounts live at
 * `brandConfig.fees.{farm,home,auto}` — note this is the inner config object, NOT the
 * `{ config: { fees } }` shape @ourbranch/fee-utils generateFee expects.
 */

// Resolves the per-LOB fees block that governs a policy type (mirrors generateFee's getLobFeesConfig):
// farm for farm-based types (F/Z/Y), auto for Auto (A), home for Home (H).
export function getLobFees(policyType, brandConfig) {
  const fees = brandConfig?.fees;
  if (!fees) {
    return undefined;
  }
  if (isFarmBasedPolicyType(policyType)) {
    return fees.farm;
  }
  if (policyType === 'A') {
    return fees.auto;
  }
  if (policyType === 'H') {
    return fees.home;
  }
  return undefined;
}

// The brand-config-driven servicing fees (rewrite / NSF / late payment) are only offered in the Fee
// Selector when the brand configures an amount for this policy type's LOB — otherwise they would add
// as $0 for brands that don't charge them. All other fee types are always eligible here (their own
// state/policy-type rules are applied separately in the selector). For CFM: rewrite is auto-only,
// NSF is farm + auto, late payment is auto-only.
export function isServicingFeeEligible(feeId, policyType, brandConfig) {
  const lobFees = getLobFees(policyType, brandConfig);
  if (feeId === 'rewrite') {
    return lobFees?.rewritePolicyFee != null;
  }
  if (feeId === 'nsf') {
    return lobFees?.nsfFee != null;
  }
  if (feeId === 'late') {
    return lobFees?.latePaymentFee != null;
  }
  return true;
}
